import React from 'react';
import { Box } from '@chakra-ui/react';

export default function Settings() {
  return <Box>Settings</Box>;
}
